import styled from 'styled-components'
import { Colors, Spacing } from 'cio-design-library/design-tokens'
import Media from 'builder/styles/media'
import Typography, { FontWeights } from 'builder/styles/typography'
import Button, { ButtonSize, ButtonTheme } from 'builder/components/Button'
import { DocumentPreview } from 'builder/components/Panel/Document/styles'
import { DocumentPreviewPlaceholder } from 'builder/components/DocumentImagePreview/styles'
import ImagePlaceholder from './assets/placeholder.png'

export const UploadButton = styled.label`
  display: flex;
  width: fit-content;
  min-width: 132px;
  height: 36px;
  padding: var(--2XS, 8px) var(--XS, 12px);
  position: relative;
  justify-content: center;
  cursor: pointer;
  align-items: center;
  flex-shrink: 0;
  border-radius: var(--3XS, 4px);
  border: 1px solid ${Colors.Neutral20};
  transition: border 0.2s ease-in-out, color 0.2s ease-in-out;
  background-color: ${Colors.White};
  color: ${Colors.Neutral90};
  ${Typography.Body};
  ${FontWeights.Medium};

  &:hover {
    transition: border 0.2s ease-in-out, color 0.2s ease-in-out;
    border: 1px solid ${Colors.Blue50};
    background-color: ${Colors.White};
    color: ${Colors.Blue50};
  }
`

export const ResumeSelectionContainer = styled.div`
  margin: 0 0 16px;
  display: flex;
  gap: 18px;
  width: 100%;
  padding: 16px;
  flex-shrink: 0;
  border-radius: var(--2XS, 8px);
  border: 1px solid ${Colors.Neutral15};
  min-height: 132px;
  align-items: flex-end;

  ${Media.Phone`
    margin: 0 0 12px;
    align-items: flex-start;
    flex-direction: column-reverse;
    max-height: unset;
    padding: 12px;
  `}
`

export const SelectLeft = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 16px;
`

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const Title = styled.p`
  ${Typography.Caption};
  color: ${Colors.Neutral90};
`

export const UploadDate = styled.p`
  ${Typography.Caption};
  color: ${Colors.Neutral50};
`

export const ButtonsContainer = styled.div`
  display: flex;
  gap: ${Spacing['2XS']};

  ${Media.Phone`
    flex-direction: column;
  `}
`

export const PreviewButton = styled(Button).attrs({
  size: ButtonSize.small,
  theme: ButtonTheme.secondary,
})`
  padding: ${Spacing['2XS']} ${Spacing.XS} ${Spacing['2XS']} ${Spacing['2XS']};
  span {
    display: flex;
    gap: ${Spacing['3XS']};
  }
`

export const ChangeResumeButton = styled(Button).attrs({
  size: ButtonSize.small,
})`
  ${Media.Phone`
    width: 100%;
  `}
`

export const SpinnerContainer = styled.div`
  position: relative;
  padding: 8px 12px;
`

export const SelectRight = styled.div`
  display: flex;
  text-align: center;
  gap: 12px;
`

export const DocumentPreviewContainer = styled.div`
  width: 104px;
  position: relative;
`

export const RightBottonShadow = styled.div`
  width: 100%;
  height: 25px;
  position: absolute;
  top: 75px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #fff 100%);
`

export const PreviewDocument = styled(DocumentPreview)`
  border-radius: 6px;
  position: relative;
  height: 100px;
  border: 1px solid rgba(101, 110, 131, 0.16);

  ${DocumentPreviewPlaceholder} {
    background-size: cover;
  }
`

export const Placeholder = styled.div`
  height: 100px;
  border-radius: 6px;
  border: 1px solid rgba(101, 110, 131, 0.16);
  background-image: url(${ImagePlaceholder});
  background-repeat: no-repeat;
  background-size: contain;
`
